import { render, staticRenderFns } from "./integralGiftDetailManageList.vue?vue&type=template&id=4e2b6ef3&scoped=true"
import script from "./integralGiftDetailManageList.vue?vue&type=script&lang=js"
export * from "./integralGiftDetailManageList.vue?vue&type=script&lang=js"
import style0 from "./integralGiftDetailManageList.vue?vue&type=style&index=0&id=4e2b6ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b6ef3",
  null
  
)

export default component.exports